import * as THREE from 'three';
import { createEnvironment, updateEnvironmentAnimations } from './environment';
import { createBuilding, highlightBuilding } from './building';

let environmentGroup: THREE.Group | null = null;

/**
 * Composes the full exterior scene: bright sunny day with building.
 */
export function createExteriorScene(): THREE.Scene {
  const scene = new THREE.Scene();
  scene.name = 'exterior-scene';

  // ── Environment (sky, ground, trees, lake, ducks, birds, etc.) ──
  environmentGroup = createEnvironment();
  scene.add(environmentGroup);

  // ── Building ─────────────────────────────────────────────
  const building = createBuilding();
  scene.add(building);

  // ── Lighting (bright sunny day) ──────────────────────────
  // Ambient — warm and bright
  const ambient = new THREE.AmbientLight(0xfff5e6, 0.5);
  scene.add(ambient);

  // Sun — bright warm directional
  const sunLight = new THREE.DirectionalLight(0xffffee, 1.4);
  sunLight.position.set(5, 10, 5);
  sunLight.castShadow = true;
  sunLight.shadow.mapSize.width = 1024;
  sunLight.shadow.mapSize.height = 1024;
  sunLight.shadow.camera.near = 0.5;
  sunLight.shadow.camera.far = 30;
  sunLight.shadow.camera.left = -12;
  sunLight.shadow.camera.right = 12;
  sunLight.shadow.camera.top = 12;
  sunLight.shadow.camera.bottom = -12;
  scene.add(sunLight);

  // Hemisphere — sky blue + ground green
  const hemiLight = new THREE.HemisphereLight(0x87ceeb, 0x5aaa3a, 0.4);
  scene.add(hemiLight);

  // ── Hover/Click Handlers ─────────────────────────────────
  window.addEventListener('object-hover', ((e: CustomEvent) => {
    const obj = e.detail.object as THREE.Object3D;
    if (obj.userData.action === 'enter') {
      highlightBuilding(obj as THREE.Group, true);
    }
  }) as EventListener);

  window.addEventListener('object-unhover', ((e: CustomEvent) => {
    const obj = e.detail.object as THREE.Object3D;
    if (obj.userData.action === 'enter') {
      highlightBuilding(obj as THREE.Group, false);
    }
  }) as EventListener);

  return scene;
}

/**
 * Call each frame to animate ducks, birds, clouds.
 */
export function updateExteriorScene(elapsed: number): void {
  if (environmentGroup) {
    updateEnvironmentAnimations(environmentGroup, elapsed);
  }
}
